import { useEffect, RefObject, useMemo } from 'react';

export const useClickAway = (
  ref: RefObject<HTMLElement> | RefObject<HTMLElement>[],
  callback: (e: PointerEvent) => void,
) => {
  const refs = useMemo(() => {
    return ref instanceof Array ? ref : [ref];
  }, [ref]);

  useEffect(() => {
    const listener = (event: PointerEvent) => {
      for (const r of refs) {
        if (!r || !r.current || (event.target && r.current.contains(event.target as HTMLElement))) {
          return;
        }
      }
      callback(event);
    };
    document.addEventListener('pointerdown', listener);

    return () => {
      document.removeEventListener('pointerdown', listener);
    };
  }, [refs, callback]);
};
